import { iAccount } from "../../interfaces/account";

const ACCOUNT: iAccount = {
    user: null,
    isAuth: false,
}

export default ACCOUNT;